<template>
  <div >
    <div></div>
    <div class="tips" v-if="form_id == 0">重要提醒：所有信息一经提交无法修改，提交前请仔细核对信息！</div>
    <van-form >
      <van-field
        v-model="form.name"
        :disabled="disabled"
        required
        name="name"
        label="姓名"
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        v-model="form.telephone"
        :disabled="disabled"
        required
        name="telephone"
        label="手机号"
        type="digit"
        placeholder="手机号"
        :rules="[{ pattern: /^1\d{10}$/,required: true, message: '请填写正确手机号' }]"
      />
      <van-field
        v-model="form.title"
        :disabled="disabled"
        required
        name="title"
        label="作品名称"
        placeholder="请输入作品名称"
        :rules="[{ required: true, message: '请填写作品名称' }]"
      />
      <van-field
        v-model="form.school"
        :disabled="disabled"
        required
        name="school"
        label="学校"
        placeholder="请输入学校"
        :rules="[{ required: true, message: '请填写学校' }]"
      />
      <van-field
        v-model="form.teacher"
        :disabled="disabled"
        required
        name="teacher"
        label="指导老师"
        placeholder="请输入指导老师"
        :rules="[{ required: true, message: '请填写指导老师' }]"
      />
      <van-field
        v-model="form.teacher_telephone"
        :disabled="disabled"
        required
        name="teacher_telephone"
        label="指导老师电话"
        placeholder="请输入指导老师电话"
        :rules="[{ required: true, message: '请填写指导老师电话' }]"
      />
      <van-field  label="视频作品上传" required :disabled="disabled" :rules="[{ required: true, message: '上传作品' }]">
        <template #input>
          
          <van-uploader :disabled="disabled" class="image-list" :deletable="form_id < 1" :max-size="500 * 1024 *1024" v-model="video" :after-read="afterReadImage" accept="video/mp4" @oversize="onOversize(500)" :max-count="1" ></van-uploader>
          <p>用户需在设置中授权越牛新闻访问图片、视频或相册</p>
        </template>
      </van-field>
      
      <!-- <van-field
        v-if="form_id == 0"
        v-model="sms"
        required
        center
        clearable
        name="code"
        label="短信验证码"
        placeholder="请输入短信验证码"
        :rules="[{ required: true, message: '请输入短信验证码' }]"
      >
        <template #button>
          <van-button size="small" type="info" native-type="button" :disabled="smsSending" @click.stop="sendSms">{{smsText}}</van-button>
        </template>
      </van-field> -->
      <div v-if="form_id == 0" style="margin: 16px;padding-bottom: 2rem;" >
        <van-button round :disabled="disabled" block type="info" @click="submit">{{ submitting ? '正在提交...': (disabled ? submitBtnText : '提交') }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>

import axios from 'axios'
// import Compressor from 'compressorjs'
import { util,mc } from '../../assets/common2.js'
import { ImagePreview } from 'vant'
// import Vconsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new Vconsole()
export default {
  name: 'YmwhxjForm',
  props: {
  },
  data () {
    return {
      form_id: 0,
      video: [],
      form:{
        name:'',
        telephone: '',
        title: '',
        school: '',
        teacher: '',
        teacher_telephone: ''
      },
      video_id: null,
      disclaimer: false,
      submitting: false,
      disabled: false,
      currentDate: new Date(1990,0,1),
      minDate: new Date(1920, 0, 1),
      maxDate: new Date(2020, 0, 1),
      showPicker: false,
      sms: '',
      smsSending: false,
      smsText: '发送验证码',
      showSubdistrictPicker: false,
      submitBtnText: '已提交',
      canRefresh: false,
      refreshing: false,
    }
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  created: function () {
    if (!mc.isClient()) {
      this.$router.replace('/runner/index')
    } else {
      this.form_id = this.$route.params.form_id
      this.fid = 14
      document.title = '“越知越行”绍兴市首届阳明文化宣讲大赛报名'
    }
    
    // this.active = this.$store.state.prevActive
  },
  mounted: function () {
    // console.log(vConsole);
  },
  methods: {
    onSelectBirthday(date) {
      this.form.birthday = date.toLocaleString().split(' ')[0]
      this.showPicker = false
    },
    priceValidate (val) {
      return val >= 50000
    },
    subdistrictConfirm(value) {
      this.form.subdistrict = value
      this.showSubdistrictPicker = false
    },
    formatter(type, val) {
      if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    preview(img) {
      ImagePreview([img])
    },
    onOversize (size) {
      this.$toast.fail(`文件超过${size}M`)
    },
    afterReadImage (file) {
      if (file instanceof Array) {
        util.Erequest((data) => {
          for (var f of file) {
            this.uploadHandle(f, 'video',data)
          }
        })
      } else {
        util.Erequest((data) => {
          this.uploadHandle(file, 'video',data)
        })
      }
    },
    uploadHandle(file, type,data) {
      file.status = 'uploading'
      file.message = '上传中...'
      var formdata = new FormData()
      formdata.append('file', file.file)
      axios.post(`/encrypt3/form/upload/video?fid=${this.fid}&userid=${data['data']['userid']}&timestamp=${data['data']['timestamp']}&sign=${data['data']['signature']}&nonce=${data['data']['nonce']}`, formdata).then(res => {
        if (res.data.msg == 'ok') {
          file.status = 'done'
          file.message = ''
          this.video_id = res.data.uuid
        } else {
          file.status = 'failed'
          file.message = '上传失败'
        }
      }).catch(() => {
        file.status = 'failed'
        file.message = '上传失败'
      })
    },
    submit() {
      this.$dialog.confirm({
        title: '确认提交',
        message: '一经提交无法修改'
      }).then(() => {
        if (this.validate()) {
          this.onSubmit()
        }
      })
    },
    sendSms() {
      if (this.smsSending) {
        return
      }
      if (this.form.telephone == '') {
        this.$toast('请先填写手机号')
        return
      }
      util.Arequest((data) => {
        this.smsSending = true
        var formData = new FormData()
        formData.append('token',data.token)
        formData.append('telephone',this.form.telephone)
        formData.append('userid',data.userid)
        axios.post(`/encrypt3/form/sms?fid=${this.fid}`,formData).then(res =>{
          if (res.data.msg == 'ok') {
            var countDown = 90
            this.smsText = `${countDown}s`
            var t = setInterval(() => {
              if (countDown <= 0) {
                clearInterval(t)
                this.smsSending = false
                this.smsText = '发送验证码'
              } else {
                countDown -= 1
                this.smsText = `${countDown}s`
              }
            },1000)
          } else {
            this.smsSending = false
            this.$toast('网络繁忙\n请稍后重试')
          }
        }).catch(() => {
          this.smsSending = false
        })
      })
    },
    validate() {
      for (const key in this.form) {
        let element = this.form[key]
        if (element == '') {
          this.$toast('请填写完整信息')
          return false
        }
      }
      return true
    },
    onSubmit() {
      
      if (this.submitting) {
        return
      }
      util.Arequest((data) => {
        this.disabled = true
        this.submitting = true
        var formData = new FormData()
        formData.append('token',data.token)
        formData.append('telephone',this.form.telephone)
        formData.append('userid',data.userid)
        formData.append('title',this.form.title)
        formData.append('name',this.form.name)
        formData.append('video',this.video_id)
        formData.append('teacher',this.form.teacher)
        formData.append('teacher_telephone',this.form.teacher_telephone)
        formData.append('school',this.form.school)
        axios.post(`/encrypt3/form/ymxhxj/submit?fid=${this.fid}`,formData).then(res => {
            if (res.data.msg == 'ok') {
              this.$store.commit('setNeedRefresh',true)
              this.$toast('提交成功')
              this.submitBtnText = '提交成功'
              setTimeout(() => {
                this.$router.go(-1)
              },1000)
            } else if (res.data.msg == 'not admin') {
              this.$toast('无权限')
              this.submitBtnText = '无权限'
            } else if (res.data.msg == 'exists') {
              this.$toast('用户已有报名\n无法再次提交')
              this.submitBtnText = '已有报名，无法再次提交'
            } else if (res.data.msg == 'smserror') {
              this.$toast('验证码过期')
              this.disabled = false
            } else if (res.data.msg == 'no start') {
              this.disabled = false
              this.$toast('报名还未开始')
            } else if (res.data.msg == 'end') {
              this.$toast('报名已经结束')
              this.submitBtnText = '报名已经结束'
            } else if (res.data.msg == 'unavailable') {
              this.$toast('无权限')
              this.submitBtnText = '无权限'
            } else {
              this.disabled = false
              this.$toast('网络繁忙\n请稍后重试')
            }
            this.submitting = false
          }).catch(() => {
            this.submitting = false
            this.disabled = false
            this.$toast('网络繁忙\n请稍后重试')
          })
      })
    },
    showDisclaimer() {
      mc.openContentView({
        appid: 1,
        contentid: 3249528,
        siteid: 10001
      })
    }
    
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .main {
  margin-top: 56.3vw;
} */
.tips {
  font-size: 1rem;
  color: red;
  padding: 0 1rem;
  text-align: left;
  line-height: 2rem;
}
.upload-bar {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
  height: 4.5rem;
}
.upload-icon {
  position: relative;
  width: 4.5rem;
  height: 4.5rem;
}
.upload-delete {
  position: absolute;
    top: 0;
    right: 0;
    width: 14px;
    height: 14px;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 0 0 0 12px;
}
.upload-tips {
  margin-left: 2rem;
  width: 6rem;
  font-size: 0.8rem;
  color: rgb(255, 76, 76);
}
.upload-list {
  display: flex;
  flex-wrap: wrap;
}
.upload-list .upload-item {
  margin-right: 0.2rem;
  margin-top: 0.2rem;
}
.disclaimer span{
  color: #1989fa;
}
</style>
